<template>
  <div
    class="footer__block"
    :class="mobileClass"
  >
    <p
      class="footer__block-title"
      @click="toggleDropdown"
    >
      {{ block.title }}
    </p>
    <ul
      v-if="block.items"
      class="footer__block-inner"
    >
      <li
        v-for="item in block.items"
        :key="item.title"
        class="footer__block-link"
      >
        <custom-link
          :href="item.link"
          :external="item.external"
        >
          {{ item.title }}
        </custom-link>
      </li>
    </ul>
    <div
      v-if="block.sections"
      class="footer__block-inner"
    >
      <div
        v-for="section in block.sections"
        :key="section.city"
      >
        <span class="footer__block-city">
          {{ section.city }}
        </span>
        <address
          class="footer__block-address"
          v-html="section.address"
        >
        </address>
        <a
          class="footer__block-tel"
          :href="`tel:${section.formattedPhone}`"
          data-gtmid="gtm-selectel-call-click"
        >
          {{ section.phone }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMenuBlock',
  props: {
    block: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      isOpened: false
    }
  },
  computed: {
    mobileClass() {
      if (this.$breakpoints.sSm) {
        return this.isOpened
          ? 'footer__block-opened'
          : 'footer__block-hidden'
      }
      return ''
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpened = !this.isOpened
    }
  }
}
</script>

<style lang="scss">
@keyframes hiding {
  0% {
    max-height: 1000px;
    opacity: 1;
  }
  100% {
    max-height: 0;
    opacity: 0;
  }
}

@keyframes opening {
  0% {
    max-height: 0;
    opacity: 0;
  }
  100% {
    max-height: 1000px;
    opacity: 1;
  }
}

.footer__block {
  width: 100%;

  @media (max-width: $breakpoint-md) {
    padding: 0 10px;
    border-bottom: 1px solid rgba(#FFF, 0.6);
  }

  &:nth-child(2) {
    @media (max-width: $breakpoint-md) {
      border-top: 1px solid rgba(#FFF, 0.6);
    }
  }
}

.footer__block-inner {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  line-height: 20px;
  list-style: none;

  @media (max-width: $breakpoint-md) {
    overflow: hidden;
    margin-left: 60px;
  }
}

.footer__block-title {
  display: block;
  margin: 0 0 16px;

  text-transform: uppercase;
  letter-spacing: 0.25px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(#FFF, 0.5);

  @media (max-width: $breakpoint-xxl + 1) {
    max-width: 200px;
  }

  @media (max-width: $breakpoint-md) {
    max-width: 100%;
    margin-bottom: 0;
    padding: 15px 0;
    position: relative;

    cursor: pointer;
    text-transform: none;
    letter-spacing: 0;
    font-weight: normal;
    color: #FFF;
  }

  &:after {
    @media (max-width: $breakpoint-md) {
      content: '';
      position: absolute;
      top: 22px;
      right: 0;
      width: 16px;
      height: 10px;
      display: block;
      background-image: url('~@/assets/icons/footer/arrowdown.svg?inline');
      transition: transform 0.4s ease;
    }
  }
}

.footer__block-opened .footer__block-title:after {
  @media (max-width: $breakpoint-md) {
    transform: rotate(180deg);
  }
}

.footer__block-opened .footer__block-inner {
  @media (max-width: $breakpoint-md) {
    animation: opening 0.5s;
    max-height: 1000px;
  }
}

.footer__block-hidden .footer__block-inner {
  @media (max-width: $breakpoint-md) {
    animation: hiding 0.3s;
    max-height: 0;
  }
}

.footer__block-link {
  margin: 0 -4px 12px;
  padding: 0 4px;
  font-size: 14px;
  line-height: 20px;
  color: #FFF;
  border-radius: 2px;
  transition: background-color 0.2s;
  cursor: pointer;

  a {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
  }

  &:hover {
    background-color: rgba(#FFF, 0.15);
  }
}

.footer__block-city {
  display: block;
  margin: 0 0 2px;
  font-size: inherit;
  color: rgba(#FFF, 0.5);

  @media (max-width: $breakpoint-xxl + 1) {
    margin: 5px 0;
  }

  @media (max-width: $breakpoint-lg) {
    margin: 0;
  }
}

.footer__block-address {
  margin: 0;
  display: block;
  font-size: inherit;
}

.footer__block-tel {
  margin-bottom: 18px;
  display: block;
  font-size: inherit;
  color: #FFF;

  @media (max-width: $breakpoint-xxl + 1) {
    margin-bottom: 12px;
  }

  @media (max-width: $breakpoint-lg) {
    margin-bottom: 19px;
  }
}
</style>